export default {
  STATION_REQUEST: "resources/STATION_REQUEST",
  STATION_RESPONSE: "resources/STATION_RESPONSE",
  COUNTRY_REQUEST: "resources/COUNTRY_REQUEST",
  COUNTRY_RESPONSE: "resources/COUNTRY_RESPONSE"
};